import { useRequest } from 'ahooks'
import { Table } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getNameLink } from '@/components/special-project-relations.component'
import { UserResourceApportionDetail } from '@/components/user-resource-dashboard/user-resource-dashboard.schemas'

export const TeamSpecificProjectDetailTable: React.FC<{ departmentId: number }> = ({ departmentId }) => {
  const { t } = useTranslation()

  const startDate = new URLSearchParams(window.location.search).get('startDate')
  const endDate = new URLSearchParams(window.location.search).get('endDate')

  const { data, run } = useRequest(
    {
      url: '/api/work-resource/statistics/team/detail/specific-project/infos',
      params: {
        startDate,
        endDate,
        departmentId,
      },
    },
    {
      manual: true,
      initialData: [] as UserResourceApportionDetail[],
    }
  )

  React.useEffect(() => {
    if (departmentId && startDate && endDate) {
      run()
    }
  }, [departmentId, startDate, endDate])

  const columns: any[] = [
    {
      title: t('标签'),
      width: 200,
      dataIndex: 'title',
      fixed: 'left',
      render: (_: any, record: any) => {
        if (record.title === 'Total') {
          return t('user resource total')
        }
        return record.selfId
          ? getNameLink({
              name: record.title,
              type: record.resourceType,
              selfId: record.selfId,
              params: { tab: 'dashboard', startDate, endDate },
            })
          : record.title
      },
    },
  ]

  const _weeks = data!.find((d) => !!d.weeks.length)?.weeks
  _weeks &&
    _weeks.forEach((week: any) => {
      columns.push({
        title: `${week.year}.${week.week} ${t('week')}`,
        children: [
          {
            title: t('分摊后工时'),
            key: `${week.year}.${week.week}.totalWorkload`,
            width: 120,
            render: (_: any, record: any) => {
              return Number(
                record.weeks.find((w: any) => w.year === week.year && w.week === week.week)?.workload ?? 0
              ).toFixed(1)
            },
          },
          {
            title: t('分摊后工时占比'),
            key: `${week.year}.${week.week}.percentage`,
            width: 120,
            render: (_: any, record: any) => {
              const percentage = record.weeks.find((w: any) => w.year === week.year && w.week === week.week)?.percentage
              return `${percentage ? (Number(percentage) * 100).toFixed(1) : 0}%`
            },
          },
        ],
      })
    })

  columns.push({
    title: t('user resource total'),
    children: [
      {
        title: t('分摊后工时'),
        key: 'totalWorkload',
        fixed: 'right',
        dataIndex: 'totalWorkload',
        width: 100,
        render: (value: any, _: any) => Number(value || 0).toFixed(1),
      },
      {
        title: t('分摊后工时占比'),
        key: 'percentage',
        fixed: 'right',
        width: 100,
        render: (_: any, record: any) => {
          return `${(Number(record.percentage) * 100).toFixed(1)}%`
        },
      },
    ],
  })

  return <Table columns={columns} dataSource={data} pagination={false} scroll={{ x: 'fit-content', y: 600 }} />
}
